import { Box } from "@mui/material";
import { useLocation } from "react-router-dom";

import { Chat } from "./Chat";

export const EmptyChatPage = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const prefillQuestion = searchParams.get("question");

  return (
    <Box
      flex={1}
      display="flex"
      flexDirection="column"
      alignItems="stretch"
      minHeight="100%"
      data-testid="hendren-empty-chat-page"
      maxWidth="900px"
      mx="auto"
    >
      <Box flex={1} display="flex" flexDirection="column" alignItems="stretch">
        <Chat prefillQuestion={prefillQuestion} />
      </Box>
    </Box>
  );
};
